import React from "react"

export default React.createContext({ company: null, companies: [], setCompany: () => null, benefits: [] })
